import ups1Movil from '../../../../assets/img/desktop/23d3e669-2250-44f1-83e6-01d3b85f64cb.jpg';
import ups2Movil from '../../../../assets/img/desktop/ca4cdf11-311f-40f2-83d5-9ed6d1a150f6.png';
import './CMContinuidadElectrica.css';

function CMContinuidadElectrica() {

    return (
        <div id="CMContinuidadElectrica">
            <section id="CE__head">
                <h2>Continuidad Eléctrica</h2>
                <ul>
                    <li>Inicio</li>
                    <li>/</li>
                    <li>Servicios</li>
                    <li>/</li>
                    <li>Continuidad Eléctrica</li>
                </ul>
            </section>
            <section id="CE__section2">
                <figure id="CE-content">
                    <img src={ups1Movil} alt="Mantenimiento de UPS" />
                </figure>
                <div id="CE-text">
                    <p id="CE-text__p1">Soluciones completas en sistemas de energía de respaldo<strong> para garantizar la continuidad operativa.</strong></p>
                    <p id="CE-text__p2">Ofrecemos servicios especializados en UPS, estabilizadores de voltaje y baterías para sistemas críticos. Nuestros equipos garantizan 
                        la protección de sus sistemas contra interrupciones eléctricas, fluctuaciones de voltaje y picos de corriente, asegurando operatividad 
                        constante en industrias, centros de datos, hospitales y comercios.</p>
                </div>
            </section>
            <section id="CE__section3">
                <div id="CEs3-content1">
                    <div id="CE3-content1__text">
                        <p id="CE3-content1__text--p1">A través de nuestro modelo de entrega único, <strong>INFRASOL</strong> provee servicios rentables; basados en Acuerdos de Niveles de Servicio (SLAs); soportados
                            por una metodología de entrega madura, alineada a las mejores prácticas y soportado en un sólido programa de calidad.</p>
                        <p id="CE3-content1__text--p2">Contamos con experiencia en planificación, diseño, implementación y gestión de proyectos de soluciones de energía
                            para resolver los requerimientos técnicos o de negocios específicos de clientes, integrando tecnología y servicios.</p>
                        <p id="CE3-content1__text--p3">Contamos con la experiencia, conocimientos y capacidades para implementar sistemas de energía de respaldo y alinearlos
                            con la estrategia de negocios de nuestros clientes.</p>
                        <p id="CE3-content1__text--p4">Nuestros servicios incluyen:</p>
                    </div>
                    <div id="CE3-content1__image">
                        <figure>
                            <img src={ups2Movil} alt="Mantenimiento de UPS" />
                        </figure>
                    </div>
                </div>
                <div id="CEs3-content2">
                    <div id="CEs3-content2__text1">
                        <div id="CEs3-content2__text1--i1">
                            <h3>Suministro e Instalación de Estabilizadores</h3>
                            <div></div>
                            <p>Ofrecemos venta, instalación, reparación y fabricación de estabilizadores monofásicos, trifásicos y ferroresonantes, 
                                diseñados para proteger tus equipos eléctricos y electrónicos frente a fluctuaciones de voltaje, picos de corriente y 
                                variaciones en la red eléctrica. Equipos con tecnología de regulación servo-controlada o electrónica, con diseño y 
                                fabricación personalizada para aplicaciones especiales.</p>
                        </div>
                        <div id="CEs3-content2__text1--i2">
                            <h3>Suministro e Instalación de Baterías para UPS</h3>
                            <div></div>
                            <p>Brindamos soluciones completas para el suministro, reemplazo, instalación y mantenimiento de baterías para sistemas UPS 
                                (de todas las marcas y capacidades). Selección de baterías VRLA, AGM, GEL o Litio, garantizando compatibilidad total 
                                con el UPS. Servicio técnico disponible 24/7 para emergencias.</p>
                        </div>
                    </div>
                    <div id="CEs3-content2__text2">
                        <h3 id="CEs3-content2__text2--i3">Mantenimiento Preventivo y Correctivo de UPS</h3>
                        <div></div>
                        <ul>
                            <li>Mantenimiento preventivo programado según horas de operación o criticidad del sistema.</li>
                            <li>Inspección interna y limpieza profunda de tarjetas, ventiladores y contactos.</li>
                            <li>Verificación de voltajes de entrada/salida, frecuencia y autonomía real.</li>
                            <li>Actualización de firmware y calibración de parámetros eléctricos.</li>
                            <li>Soporte técnico para eventos críticos, alarmas o fallas mayores.</li>
                            <li>Contratos de mantenimiento mensual, trimestral o anual según necesidad.</li>
                            <li>Generación de informes técnicos con recomendaciones de mejora.</li>
                            <li>Reducción de fallas inesperadas y prolongación de la vida útil de equipos y baterías.</li>                        
                        </ul>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default CMContinuidadElectrica;

